import React from "react";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import { css } from "@emotion/core";
import HashLoader from "react-spinners/HashLoader";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// styles
import { TitleModalStyled } from "./styles";
import "./styles.css";

// core components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";

// helpers
import { modals } from "helpers/dictionary";

const useStyles = makeStyles(styles);

const override = css`
  display: block;
  margin: 2rem auto;
`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const CancelModal = React.memo(
  ({
    colorRGB,
    modal,
    isLoading,
    title = "",
    message = "",
    onCloseModal,
    onCancel,
    children,
  }) => {
    const classes = useStyles();

    return (
      <>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal,
          }}
          open={modal}
          transition={Transition}
          keepMounted
          onClose={() => onCloseModal(modals.cancel)}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => onCloseModal(modals.cancel)}
            >
              <Close className={classes.modalClose} />
            </Button>
            <TitleModalStyled color={colorRGB} className={classes.modalTitle}>
              Cancelar
            </TitleModalStyled>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
            <h3>{title}</h3>
            <span>{message}</span>
            {isLoading && (
              <HashLoader
                css={override}
                size={60}
                color={`${colorRGB}`}
                loading={isLoading}
              />
            )}
            {children}
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button onClick={() => onCancel()} color="success">
              Cancelar
            </Button>
            <Button onClick={() => onCloseModal(modals.cancel)} color="info">
              Salir
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
